'use client'

import { useState } from 'react'
import { SwipeableHandlers, useSwipeable } from 'react-swipeable'

type Props = {
  slides: unknown[]
}

export const useSlider = ({
  slides,
}: Props): {
  handleNextSlide: () => void
  handlePreviousSlide: () => void
  handleSlideSelect: (index: number) => void
  touchHandlers: SwipeableHandlers
  selectedSlide: number
  slides: unknown[]
} => {
  const [selectedSlide, setSelectedSlide] = useState(0)

  const handleNextSlide = () => {
    if (selectedSlide + 1 < slides.length) {
      setSelectedSlide(selectedSlide + 1)
    }
  }

  const handlePreviousSlide = () => {
    if (selectedSlide - 1 >= 0) {
      setSelectedSlide(selectedSlide - 1)
    }
  }

  const handleSlideSelect = (index: number) => {
    setSelectedSlide(index)
  }

  const handlers = useSwipeable({
    onSwipedRight: () => {
      handlePreviousSlide()
    },
    onSwipedLeft: () => {
      handleNextSlide()
    },
  })

  return {
    handleNextSlide,
    handlePreviousSlide,
    handleSlideSelect,
    touchHandlers: handlers,
    selectedSlide,
    slides,
  }
}
